import React from 'react';
import ScrollReveal from '../Animation/ScrollReveal';
import './AgileMethodology.css';

const AgileMethodology: React.FC = () => {
  // SVG Icons
  const Icons = {
    Requirements: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
      </svg>
    ),
    Planning: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
      </svg>
    ),
    Development: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
      </svg>
    ),
    Testing: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
    Deployment: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    Maintenance: () => (
      <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M12 8v4M12 16h.01" />
      </svg>
    ),
    Plan: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    Design: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    Develop: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
      </svg>
    ),
    Test: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
    Review: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    Deploy: () => (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
    ProductOwner: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="8" r="4" />
        <path d="M5.5 20v-4a2 2 0 012-2h9a2 2 0 012 2v4" />
        <path d="M16 8a4 4 0 00-8 0" />
        <path d="M12 12v4" />
      </svg>
    ),
    ScrumMaster: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
    Team: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87" />
        <path d="M16 3.13a4 4 0 010 7.75" />
      </svg>
    ),
    SprintPlanning: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M8 14h.01M12 14h.01M16 14h.01" />
      </svg>
    ),
    Standup: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
        <line x1="8" y1="10" x2="8" y2="10" />
        <line x1="16" y1="10" x2="16" y2="10" />
      </svg>
    ),
    SprintReview: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
        <polyline points="17 6 23 6 23 12" />
      </svg>
    ),
    Retrospective: () => (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 12a9 9 0 11-9-9" />
        <polyline points="12 3 12 12 16 14" />
        <path d="M22 6L12 16" />
      </svg>
    ),
  };

  // SDLC Phases data
  const sdlcPhases = [
    {
      id: 1,
      title: 'Requirements Gathering',
      icon: <Icons.Requirements />,
      description: 'We work closely with stakeholders to understand business needs, define project scope, and document functional and non-functional requirements.',
      activities: [
        'Stakeholder interviews and workshops',
        'Requirements documentation',
        'Feasibility analysis',
        'Project scope definition'
      ]
    },
    {
      id: 2,
      title: 'Planning & Design',
      icon: <Icons.Planning />,
      description: 'Our team creates architectural designs, user interface mockups, and detailed technical specifications for the development phase.',
      activities: [
        'System architecture design',
        'Database schema design',
        'UI/UX wireframing',
        'Technology stack selection',
        'Sprint planning'
      ]
    },
    {
      id: 3,
      title: 'Development',
      icon: <Icons.Development />,
      description: 'Our developers write clean, maintainable code following best practices and coding standards, implementing features in iterative sprints.',
      activities: [
        'Feature implementation',
        'Code reviews',
        'Continuous integration',
        'Unit testing',
        'Version control management'
      ]
    },
    {
      id: 4,
      title: 'Testing',
      icon: <Icons.Testing />,
      description: 'Comprehensive testing ensures quality, reliability, and performance across all platforms and devices.',
      activities: [
        'Unit testing',
        'Integration testing',
        'System testing',
        'User acceptance testing (UAT)',
        'Performance testing'
      ]
    },
    {
      id: 5,
      title: 'Deployment',
      icon: <Icons.Deployment />,
      description: 'We deploy applications to production environments with minimal downtime and maximum reliability.',
      activities: [
        'Production deployment',
        'Data migration',
        'Server configuration',
        'Deployment automation',
        'Rollback planning'
      ]
    },
    {
      id: 6,
      title: 'Maintenance & Support',
      icon: <Icons.Maintenance />,
      description: 'Our team provides ongoing support, updates, and enhancements to ensure your application remains secure and performant.',
      activities: [
        'Bug fixes and patches',
        'Performance optimization',
        'Security updates',
        'Feature enhancements',
        'Technical support'
      ]
    }
  ];

  return (
    <div id="agile-methodology" className="agile-methodology-wrapper">
      <div className="agile-container">
        {/* Hero Section */}
        <ScrollReveal direction="up" duration={0.6}>
          <section className="agile-hero-section">
            <div className="agile-hero-content">
              <h1 className="agile-hero-title">Agile Methodology</h1>
              <p className="agile-hero-subtitle">
                Our approach to delivering exceptional software through iterative development, 
                continuous collaboration, and adaptive planning.
              </p>
            </div>
          </section>
        </ScrollReveal>

        {/* Agile Overview */}
        <ScrollReveal direction="up" duration={0.6} delay={0.1}>
          <section className="agile-overview-section">
            <div className="agile-overview-grid">
              <div className="agile-overview-text">
                <h2>What is Agile?</h2>
                <p>
                  Agile is a project management and software development approach that emphasizes 
                  flexibility, collaboration, and customer satisfaction. Unlike traditional waterfall 
                  methodology, Agile breaks projects into small, manageable iterations called sprints, 
                  allowing teams to respond quickly to changes and deliver value continuously.
                </p>
              </div>
              <div className="agile-overview-image">
                <div className="agile-cycle-grid">
                  <div className="agile-cycle-item"><Icons.Plan /> Plan</div>
                  <div className="agile-cycle-item"><Icons.Design /> Design</div>
                  <div className="agile-cycle-item"><Icons.Develop /> Develop</div>
                  <div className="agile-cycle-item"><Icons.Test /> Test</div>
                  <div className="agile-cycle-item"><Icons.Review /> Review</div>
                  <div className="agile-cycle-item"><Icons.Deploy /> Deploy</div>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* SDLC Phases Header */}
        <ScrollReveal direction="up" duration={0.6} delay={0.2}>
          <section className="agile-sdlc-section">
            <div className="agile-section-header">
              <h2>Software Development Life Cycle (SDLC)</h2>
              <p className="agile-section-subtitle">Our systematic approach to building high-quality software from conception to deployment</p>
            </div>
          </section>
        </ScrollReveal>

        {/* SDLC Phases Timeline */}
        <div className="agile-sdlc-timeline">
          {sdlcPhases.map((phase, index) => (
            <ScrollReveal 
              key={phase.id} 
              direction="up" 
              duration={0.5} 
              delay={0.05 * (index + 1)}
            >
              <div className="agile-sdlc-phase">
                <div className="agile-sdlc-connector">
                  {index < sdlcPhases.length - 1 && (
                    <div className="agile-sdlc-line"></div>
                  )}
                </div>
                <div className="agile-sdlc-content">
                  <div className="agile-sdlc-icon">{phase.icon}</div>
                  <div className="agile-sdlc-number">{phase.id}</div>
                  <h3>{phase.title}</h3>
                  <p className="agile-sdlc-description">{phase.description}</p>
                  <ul className="agile-sdlc-activities">
                    {phase.activities.map((activity, idx) => (
                      <li key={idx}>{activity}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Scrum Framework Header */}
        <ScrollReveal direction="up" duration={0.6} delay={0.3}>
          <section className="agile-scrum-section">
            <div className="agile-section-header">
              <h2>Our Scrum Framework</h2>
              <p className="agile-section-subtitle">How we implement Agile through Scrum methodology</p>
            </div>
          </section>
        </ScrollReveal>

        {/* Scrum Grid */}
        <div className="agile-scrum-grid">
          <ScrollReveal direction="left" duration={0.6} delay={0.1}>
            <div className="agile-scrum-roles">
              <h3>Scrum Roles</h3>
              <div className="agile-scrum-role-list">
                <div className="agile-scrum-role">
                  <div className="agile-scrum-role-icon"><Icons.ProductOwner /></div>
                  <h4>Product Owner</h4>
                  <p>Represents stakeholders, prioritizes backlog, and ensures value delivery</p>
                </div>
                <div className="agile-scrum-role">
                  <div className="agile-scrum-role-icon"><Icons.ScrumMaster /></div>
                  <h4>Scrum Master</h4>
                  <p>Facilitates ceremonies, removes impediments, and coaches the team</p>
                </div>
                <div className="agile-scrum-role">
                  <div className="agile-scrum-role-icon"><Icons.Team /></div>
                  <h4>Development Team</h4>
                  <p>Self-organizing cross-functional team that delivers working software</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" duration={0.6} delay={0.2}>
            <div className="agile-scrum-ceremonies">
              <h3>Scrum Ceremonies</h3>
              <div className="agile-scrum-ceremony-list">
                <div className="agile-scrum-ceremony">
                  <div className="agile-scrum-ceremony-icon"><Icons.SprintPlanning /></div>
                  <h4>Sprint Planning</h4>
                  <p>Plan the work to be completed in the upcoming sprint</p>
                </div>
                <div className="agile-scrum-ceremony">
                  <div className="agile-scrum-ceremony-icon"><Icons.Standup /></div>
                  <h4>Daily Standup</h4>
                  <p>15-minute daily meeting to synchronize the team</p>
                </div>
                <div className="agile-scrum-ceremony">
                  <div className="agile-scrum-ceremony-icon"><Icons.SprintReview /></div>
                  <h4>Sprint Review</h4>
                  <p>Demonstrate completed work to stakeholders</p>
                </div>
                <div className="agile-scrum-ceremony">
                  <div className="agile-scrum-ceremony-icon"><Icons.Retrospective /></div>
                  <h4>Sprint Retrospective</h4>
                  <p>Reflect on the sprint and identify improvements</p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
};

export default AgileMethodology;